module.exports = __webpack_public_path__ + "assets/ef45cf059bac93cd104486d1310ba79b.mp3";